import { render, staticRenderFns } from "./zqAreaMsg.vue?vue&type=template&id=8fe0e424&"
import script from "./zqAreaMsg.vue?vue&type=script&lang=js&"
export * from "./zqAreaMsg.vue?vue&type=script&lang=js&"
import style0 from "./zqAreaMsg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports